import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  line-height: 24px;\n  text-align: center;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  &&& {\n    height: 100px;\n    width: 100px;\n  }\n  @media screen and (max-width: ", "px) {\n    margin-top: 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: center;\n  flex: 1;\n  position: relative;\n  margin: 0 auto;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { useLottie } from 'lottie-react';
import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { Bold } from '../Typography/Bold';
import { LOADING_SPINNER, LOADING_MESSAGE } from '../utils/testing/TestIDs';
import styled from '../utils/styling/styled-components';
import animationData from './loader.json';
var Container = styled.div(_templateObject());
var SpinnerContainer = styled.div(_templateObject2(), function (props) {
  return props.theme.breakpoints.sm;
});
var StyledTitle = styled.div(_templateObject3());
var SEGMENT_INCOMPLETE = [0, 90];
var SEGMENT_COMPLETE = [90, 190];
var SEGMENT_STATIC = [160, 160];
export var Loader = function Loader(_ref) {
  var onAnimationEnd = _ref.onAnimationEnd,
      isStatic = _ref.isStatic,
      message = _ref.message,
      loading = _ref.loading,
      _ref$startSegment = _ref.startSegment,
      startSegment = _ref$startSegment === void 0 ? SEGMENT_INCOMPLETE : _ref$startSegment,
      _ref$endSegment = _ref.endSegment,
      endSegment = _ref$endSegment === void 0 ? SEGMENT_COMPLETE : _ref$endSegment,
      _ref$minimumAnimation = _ref.minimumAnimationTime,
      minimumAnimationTime = _ref$minimumAnimation === void 0 ? 0 : _ref$minimumAnimation;

  var _useState = useState(isStatic ? false : true),
      _useState2 = _slicedToArray(_useState, 2),
      loop = _useState2[0],
      setLoop = _useState2[1];

  var _useState3 = useState(isStatic ? SEGMENT_STATIC : startSegment),
      _useState4 = _slicedToArray(_useState3, 2),
      segment = _useState4[0],
      setSegment = _useState4[1];

  var options = {
    animationData: animationData,
    loop: loop,
    onComplete: function onComplete() {
      if (onAnimationEnd) {
        onAnimationEnd();
      }
    },
    initialSegment: segment
  };

  var _useLottie = useLottie(options),
      View = _useLottie.View;

  useEffect(function () {
    if (!loading && !isStatic) {
      setTimeout(function () {
        setLoop(1);
        setSegment(endSegment);
      }, minimumAnimationTime);
    }
  }, [loading]);
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(SpinnerContainer, {
    "data-testid": LOADING_SPINNER
  }, View), message && /*#__PURE__*/React.createElement(motion.div, {
    animate: loading ? 'visible' : 'hidden',
    transition: {
      delay: 1.5,
      duration: 0.5,
      ease: 'easeInOut'
    },
    variants: {
      hidden: {
        opacity: 0,
        y: -20
      },
      visible: {
        opacity: 1,
        y: 0
      }
    }
  }, /*#__PURE__*/React.createElement(StyledTitle, {
    "data-testid": LOADING_MESSAGE
  }, /*#__PURE__*/React.createElement(Bold, null, message))));
};